<script lang="ts">
	import {
		BaseInput,
		PrimaryKeyFieldLabel,
		PrimaryKeyIcon,
		Toggle,
		ToggleSize
	} from '@repo/commons/components'
	import {
		getSchemaColumnTypeConfig,
		isBooleanColumnType,
		type RowFieldValue
	} from '@repo/commons/utils'
	import type { ResourceSchemaColumn } from '@semanticedge/persistence-service-noheaders-client/src'

	type Props = {
		columnName: string
		column: ResourceSchemaColumn
		value: RowFieldValue | undefined
		error?: string
		onChange: (columnName: string, value: RowFieldValue) => void
	}

	const { columnName, column, value, error, onChange }: Props = $props()

	const fieldId = $derived(`reference-table-row-${columnName}`)
	const isBoolean = $derived(isBooleanColumnType(column.type))
	const numberType = $derived(getSchemaColumnTypeConfig(column.type).numberType)

	const handleChange = (next: RowFieldValue): void => {
		onChange(columnName, next)
	}
</script>

{#if isBoolean}
	<div class="field">
		<div class="toggle-row">
			<Toggle
				label={columnName}
				value={Boolean(value)}
				size={ToggleSize.MEDIUM}
				onchange={handleChange}
			/>
			{#if column.primaryKey}
				<PrimaryKeyIcon />
			{/if}
		</div>

		{#if error}
			<p class="field-error">{error}</p>
		{/if}
	</div>
{:else}
	<div class="field">
		<PrimaryKeyFieldLabel text={columnName} showPrimaryKey={column.primaryKey} htmlFor={fieldId} />
		<BaseInput
			id={fieldId}
			label=""
			value={String(value ?? '')}
			size="md"
			{numberType}
			onInput={handleChange}
			showError={!!error}
			errorMessage={error}
		/>
	</div>
{/if}

<style lang="postcss">
	.field {
		@apply flex flex-col gap-1;
	}

	.toggle-row {
		@apply inline-flex items-center gap-2;
	}

	.field-error {
		@apply text-sm text-red-500;
	}
</style>
